import React from 'react'

const Spinner = () => {
  return (
    <div className='flex justify-center'>
      <div className='spinner'></div>
    </div>
  )
}

export default Spinner